import React, { Component, Fragment } from "react";
import { curdActions } from "../../reduxCURD/actions.js";
import _ from "lodash";
import ThisTable from "../Common/ThisTable/index.jsx";
import { languageService } from "../../Language/language.service.js";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";
import { commonPageStyle } from "../Common/Summary/styles/CommonPageStyle.js";
import { CRUDFunction } from "../../reduxCURD/container.js";
import { commonFilterStyles } from "../Common/Filters/styles/CommonFilterStyle.js";
import { PillTextButton } from "../../libraries/GeneralButtons/index.jsx";
import moment from "moment";
import { getAllInspectableAssets } from "../../reduxRelated/actions/assetHelperAction.js";
import { themeService } from "../../theme/service/activeTheme.service.js";
import { downloadCsv } from "../../utils/downloadCsv.js";
import { encodeForCSV } from "../../utils/csvFormatter.js";
import { SelectField } from "../Reports/Timps/reportfilter.jsx";

class AssetNomenclatureList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      page: 0,
      pageSize: 30,
      assetNomenclatureLists: [],
      filteredAssetNomenclatureLists: [],
      columns: [],
      selectedAssetType: "All",
      assetTypesOptions: [],
    };

    this.handlePageSave = this.handlePageSave.bind(this);
    this.pageOptions = [5, 10, 15, 20, 25, 30, 40, 50];
    this.toggle = this.toggle.bind(this);
    this.exportToCsv = this.exportToCsv.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
  }

  componentDidMount() {
    this.props.getAllInspectableAssets(["unitId", "appFormLists", "location", "assetType", "start", "end"]);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.assetHelperActionType == "GET_ALLINSPECTABLE_ASSETS_SUCCESS" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.props.getApplicationlookupss(["appFormLists"]);
    }

    if (
      prevProps.applicationlookupsActionType !== this.props.applicationlookupsActionType &&
      this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_SUCCESS"
    ) {
      this.props.allInspectableUserAssets &&
        this.props.allInspectableUserAssets.assets &&
        this.setAssetNomenclatureListData(this.props.allInspectableUserAssets.assets, this.props.applicationlookupss);
    }
  }
  setAssetNomenclatureListData(assets, appFormLists) {
    let assetNomenclatureLists = [];
    let assetTypesOptions = new Map([["All", { val: "All", text: "All" }]]);

    assets.forEach((asset) => {
      let includeAsset = false;
      const AssetNomenclatureSet =
        asset.appFormLists && asset.appFormLists.length
          ? asset.appFormLists.reduce((map, item) => {
              map[item.id] = item.values;
              return map;
            }, {})
          : {};

      const missingAppFormLists = appFormLists.reduce((acc, item) => {
        let valuesCount =
          AssetNomenclatureSet[item.code] && AssetNomenclatureSet[item.code].length > 0 ? AssetNomenclatureSet[item.code].length : 0;
        if (!includeAsset && valuesCount === 0) includeAsset = true;
        acc[item.code] = { name: item.description, valuesCount: valuesCount };
        return acc;
      }, {});

      includeAsset &&
        assetNomenclatureLists.push({
          ...asset,
          ...missingAppFormLists,
        });

      if (!assetTypesOptions.has(asset.assetType)) {
        assetTypesOptions.set(asset.assetType, { val: asset.assetType, text: asset.assetType });
      }
    });

    // Update the state
    this.setState({
      assetNomenclatureLists: assetNomenclatureLists,
      filteredAssetNomenclatureLists: assetNomenclatureLists,
      assetTypesOptions: Array.from(assetTypesOptions.values()),
      columns: [
        {
          Header: languageService("Asset Name"),
          accessor: "unitId",
          minWidth: 80,
        },
        {
          Header: languageService("Asset Type"),
          accessor: "assetType",
          minWidth: 80,
        },
        {
          Header: languageService("Location"),
          accessor: "location",
          minWidth: 80,
        },
        {
          Header: languageService("Start (milepost)"),
          accessor: "start",
          minWidth: 80,
        },

        ...appFormLists.map((item) => ({
          Header: languageService(item.description),
          accessor: item.code,
          minWidth: 50,
          Cell: ({ value }) => <div style={{ color: value.valuesCount ? "inherit" : "red", fontWeight: "bold" }}>{value.valuesCount}</div>,
        })),
      ],
    });
  }

  exportToCsv() {
    const { filteredAssetNomenclatureLists } = this.state;
    const formattedData = filteredAssetNomenclatureLists.map((asset) => ({
      "Asset Name": encodeForCSV(asset.unitId),
      "Asset Type": encodeForCSV(asset.assetType),
      Location: encodeForCSV(asset.location),
      "Start (milepost)": encodeForCSV(asset.start),
      ...Object.entries(asset).reduce((acc, [key, value]) => {
        if (!["unitId", "_id", "appFormLists", "location", "assetType", "start", "end"].includes(key)) {
          acc[value.name] = encodeForCSV(value.valuesCount);
        }
        return acc;
      }, {}),
    }));

    // Using the provided downloadCsv function
    downloadCsv(formattedData, document, `AssetNomenclatureList_${moment(new Date()).format("YYYY-MM-DD")}`, "assets");
  }

  handlePageSave(page, pageSize) {
    this.setState({
      page: page,
      pageSize: pageSize,
    });
  }
  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }
  changeHandler(e) {
    const name = e.target.name;
    const value = e.target.value;

    let filteredAssetNomenclatureLists =
      value === "All" ? this.state.assetNomenclatureLists : this.state.assetNomenclatureLists.filter((a) => a.assetType === value);

    this.setState({ selectedAssetType: value, filteredAssetNomenclatureLists: filteredAssetNomenclatureLists });
  }
  render() {
    let pageOptions = null;
    pageOptions = this.pageOptions.map((option) => {
      return (
        <DropdownItem
          onClick={(e) => {
            this.handlePageSave(0, option);
          }}
          key={option}
          style={themeService(commonFilterStyles.pageSizeStyle)}
        >
          {option}
        </DropdownItem>
      );
    });
    return (
      <React.Fragment>
        <Col className="mainContent" md="12">
          <Row>
            <Col md="12">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={themeService(commonPageStyle.commonSummaryHeadingStyle)}>{languageService("Asset Nomenclatures List")}</span>
                {this.state.filteredAssetNomenclatureLists.length > 0 && (
                  <SelectField
                    inputFieldProps={{ name: "assetType", label: "Asset Type" }}
                    options={this.state.assetTypesOptions}
                    changeHandler={this.changeHandler}
                    value={this.state.selectedAssetType}
                  />
                )}
                {this.state.filteredAssetNomenclatureLists.length > 0 && (
                  <PillTextButton
                    title={languageService("Export to CSV")}
                    onClick={this.exportToCsv}
                    style={{ fontSize: "12px", width: "max-content" }}
                  />
                )}
              </div>
            </Col>

            <hr style={{ borderBottom: "1px solid rgb(209, 209, 209)", width: "96.5%" }}></hr>
          </Row>
          <Row>
            <Col md={1}>
              <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }} key="pageSize">
                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} size="sm">
                  <DropdownToggle style={themeService(commonFilterStyles.pageSizeTogglerStyle)} caret>
                    {this.state.pageSize}
                  </DropdownToggle>
                  <DropdownMenu style={{ minWidth: "auto", fontSize: "12px", padding: "0px" }}>{pageOptions}</DropdownMenu>
                </Dropdown>
              </div>
            </Col>

            <Col md="12">
              <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }}>
                <ThisTable
                  tableColumns={this.state.columns}
                  tableData={this.state.filteredAssetNomenclatureLists}
                  pageSize={this.state.pageSize}
                  minRows={1}
                  pagination={true}
                  forDashboard={false}
                  handlePageChange={(page) => this.handlePageSave(page, this.state.pageSize)}
                  page={this.state.page}
                  height={"auto"}
                  // handleSelectedClick={this.setSelectedUser}
                  onClickSelect
                />
              </div>
            </Col>
          </Row>
        </Col>
      </React.Fragment>
    );
  }
}

const getApplicationlookupss = curdActions.getApplicationlookupss;

let variables = {
  assetReducer: { assets: [] },

  applicationlookupsReducer: {
    applicationlookupss: [],
  },
  assetHelperReducer: {
    allInspectableUserAssets: [],
  },
};

let containerReducers = ["assetReducer", "applicationlookupsReducer", "assetHelperReducer"];

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: {
    getAllInspectableAssets,
    getApplicationlookupss: getApplicationlookupss,
  },
};

let AssetNomenclatureListContainer = CRUDFunction(
  AssetNomenclatureList,
  "AssetNomenclaturesList",
  actionOptions,
  variables,
  containerReducers,
  "asset",
);
export default AssetNomenclatureListContainer;



// WEBPACK FOOTER //
// ./src/components/AssetNomenclatureList/index.jsx